import { Router } from 'next/router'
import { featureFlagsClient, initializeFeatureFlags } from './client'

let didBootstrap = false

const syncFeatureFlagsUrl = (): void => {
  void featureFlagsClient.setURL(globalThis.location.href)
}

export const bootstrapFeatureFlags = (): void => {
  if (globalThis.window === undefined || didBootstrap) return

  didBootstrap = true

  void initializeFeatureFlags()

  syncFeatureFlagsUrl()
  Router.events.on('routeChangeComplete', syncFeatureFlagsUrl)
}
